import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  NgModule,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { SafeUrlPipeModule } from '../../pipes/safe-url.pipe';
import { GTMService } from '../../shared/gtm.service';
import { isIFrameSameOrigin } from '../../shared/helpers/is-same-origin';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { OneSignalService } from '../../shared/one-signal.service';
import { TranslatePipeModule } from '../../shared/translate.pipe';
import { AnalyticsOutcomeEvents } from '../../shared/types/analytics-outcome.types';
import { IFrameSizeEventType } from '../../shared/types/iframe-event-type';
import { LCOboardingEventType } from '../../shared/types/lc-onboarding-event-type';

const OFFSET_HEIGHT = 80;

@Component({
  selector: 'lp2-lc-onboarding-iframe',
  template: `
    <h1 class="title">{{ 'oeapp.lconboarding.title.title' | translate }}</h1>

    <iframe
      #iframe
      *ngIf="lcOnboardingUrl"
      [src]="lcOnboardingUrl | safeUrl"
      frameborder="0"
      [ngClass]="{ 'lc-onboarding-iframe-lfa': oeAppPersonService.isLfa }"
      class="container lc-onboarding-iframe"
    >
    </iframe>
  `,
  styleUrls: ['./lc-onboarding-iframe.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LcOnboardingIframeComponent implements OnInit, OnDestroy {
  @Output()
  public onboardingFinished = new EventEmitter<string>();

  @ViewChild('iframe')
  public iframe: ElementRef<HTMLIFrameElement>;

  public lcOnboardingUrl: string;

  constructor(
    private gtmService: GTMService,
    private oeApp: OeAppService,
    public oeAppPersonService: OeAppPersonService,
    private cdRef: ChangeDetectorRef,
    private oneSignalService: OneSignalService
  ) {}

  ngOnInit() {
    const environment = this.oeApp.environment;
    const contactId = this.oeAppPersonService.contactId;
    const personId = this.oeAppPersonService.id;

    if (environment && contactId) {
      this.lcOnboardingUrl =
        this.oeApp.webLcOnboardingPageHost +
        '?env=' +
        environment +
        '&contactId=' +
        contactId +
        '&personId=' +
        personId +
        '&bilingualEnabled=' +
        this.oeAppPersonService.isBilingualEnabled +
        '&lfa=' +
        this.oeAppPersonService.isLfa +
        '&lang=' +
        this.oeAppPersonService.preferredLang;
      this.cdRef.markForCheck();
    }

    window.addEventListener('message', this.handleEvents.bind(this), false);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleEvents);
  }

  private handleEvents({ data, origin }) {
    if (!isIFrameSameOrigin(this.oeApp.webLcOnboardingPageHost, origin)) {
      return;
    }

    switch (data.type) {
      case LCOboardingEventType.LC_ONBOARDING_FINISHED:
        this.oneSignalService.trackOutcome(AnalyticsOutcomeEvents.LC_ONBOARDING_COMPLETED);
        this.onboardingFinished.emit(data.data.data);
        break;
      case LCOboardingEventType.LC_ONBOARDING_TRACKING_EVENT:
        this.gtmService.sendGA4Event(data.data.event);
        break;
      case IFrameSizeEventType.HEIGHT:
        this.iframe.nativeElement.height = data.height + OFFSET_HEIGHT;
        break;
    }
  }
}

@NgModule({
  imports: [CommonModule, SafeUrlPipeModule, TranslatePipeModule],
  declarations: [LcOnboardingIframeComponent],
  exports: [LcOnboardingIframeComponent],
})
export class LCOnboardingIframeModule {}



// WEBPACK FOOTER //
// ./ts/app/components/lc-onboarding-iframe/lc-onboarding-iframe.component.ts